<template>
  <v-chart ref="chart" class="chart" :option="option" />
</template>

<script>
export default {
  name: 'funnelChart1',
  props: {
    avadata: Object,
    simpleavadata: Object,
    showDemo: String
  },
  data() {
    return {
      option: { },
      owndata: {}
    }
  },
  watch: {
    treemapdata: {
      handler(newValue, oldValue) {
        this.owndata = newValue
        this.getDataView()
      }
    }
  },
  mounted() {
    console.log('[funnelChart1/mounted]')
    this.$nextTick(() => {
      if (this.showDemo == 'true') {
        this.owndata = this.avadata
        this.getDataView()
      } else {
        this.owndata = this.simpleavadata
        setTimeout(() => {
          this.getDataView()
        }, 2000)
      }
    })
  },
  methods: {
    getDataView() {
      console.log('[funnelChart1/getDataView]');
      // this.axios.get('api/kcapi/get_sexandage').then((response) => {
      console.log(this.owndata)
      this.option = {

          title: {
            //text: 'Funnel'
          },
          /*tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}%'
          },
          toolbox: {
          },*/
          legend: {
            show: false,
            data: ['自驱需要', '尊重需要', '社会需要', '安全需要', '存活需要']
          },
          series: [
            {
              name: 'Funnel',
              type: 'funnel',
              left: '10%',
              top: 60,
              bottom: 60,
              width: '80%',
              min: 0,
              max: 100,
              minSize: '0%',
              maxSize: '100%',
              //sort: 'descending',
              sort: 'ascending',
              gap: 2,
              label: {
                show: true,
                position: 'inside'
              },
              labelLine: {
                length: 10,
                lineStyle: {
                  width: 1,
                  type: 'solid'
                }
              },
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 1
              },
              emphasis: {
                label: {
                  fontSize: 20
                }
              },
              data: [
                { value: 20, name: '自驱需要' },
                { value: 40, name: '尊重需要' },
                { value: 60, name: '社会需要' },
                { value: 80, name: '安全需要' },
                { value: 100, name: '存活需要' }
              ]
            }
          ]


      }
      // }).catch((response) => {
      //   console.log(response)
      // })
      this.$refs['chart'].setOption(this.option);
    },
    resize() {
      this.$refs['chart'].resize()
    }
  }
}
</script>

<style>

</style>
